<button mat-stroked-button color="primary" (click)="openModal()">Modificar Datos</button>

<ng-template #datetimeModal>
  <h2 mat-dialog-title>Modificación de fecha</h2>
  <mat-dialog-content class="dtp-content">
    <div class="dtp-grid">
      <mat-form-field appearance="outline" class="dtp-datepicker">
        <mat-label>Fecha</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [(ngModel)]="selectedDate"
          [ngModelOptions]="{ standalone: true }"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <div class="dtp-time">
        <div class="dtp-time-block">
          <span class="dtp-time-label">Horas</span>
          <div class="dtp-time-controls">
            <button mat-icon-button (click)="sumarHoras()"><mat-icon>expand_less</mat-icon></button>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="number"
                [(ngModel)]="contadorHoras"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="23"
              />
            </mat-form-field>
            <button mat-icon-button (click)="restarHoras()"><mat-icon>expand_more</mat-icon></button>
          </div>
        </div>

        <div class="dtp-time-block">
          <span class="dtp-time-label">Minutos</span>
          <div class="dtp-time-controls">
            <button mat-icon-button (click)="sumarMinutos()"><mat-icon>expand_less</mat-icon></button>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="number"
                [(ngModel)]="contadorMinutos"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="59"
              />
            </mat-form-field>
            <button mat-icon-button (click)="restarMinutos()"><mat-icon>expand_more</mat-icon></button>
          </div>
        </div>

        <div class="dtp-time-block">
          <span class="dtp-time-label">Segundos</span>
          <div class="dtp-time-controls">
            <button mat-icon-button (click)="sumarSegundos()"><mat-icon>expand_less</mat-icon></button>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="number"
                [(ngModel)]="contadorSegundos"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="59"
              />
            </mat-form-field>
            <button mat-icon-button (click)="restarSegundos()"><mat-icon>expand_more</mat-icon></button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef?.close()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="guardarDatos()">Guardar Datos</button>
  </mat-dialog-actions>
</ng-template>
